<template>
	<div class="actions">
		<menu v-if="$root.pointer === 'mouse'">
			<popover v-for="item in menuItems" v-bind:key="item.text" :message="item.text" :position="'right'" :is-tool-tip="true">
				<button slot="popover-target" @click="$emit('action-press', item.method)"><i :class="'fas fa-' + item.class"></i></button>
			</popover>
		</menu>
		<dropdown-menu class="dropdown" v-else>
			<button class="trigger" slot="icon-trigger"><i class="fas fa-ellipsis-v"></i></button>
			<button v-for="item in menuItems" v-bind:key="item.text" @click="$emit('action-press', item.method)"><i :class="'fas fa-' + item.class"></i>{{item.text}}</button>
		</dropdown-menu>
	</div>
</template>

<script>
import Vue from 'vue';
import Popover from './Popover.vue';
import DropdownMenu from './DropdownMenu.vue';
export default {
	name: 'Actions',
	components:{
		Popover,
		DropdownMenu
	},
	props: { list: Array },
	data() {
		return {
			menuItems: this.list
		};
	}
};
</script>

<style scoped>
	.dropdown button:not(.trigger) i {
		margin-right: .5em;
	}

	button.trigger i {
		width: 13px;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/Actions.vue